import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          精彩视频
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <article key={idx} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="aspect-[16/10] overflow-hidden relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-primary-600 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/60 rounded text-xs text-white font-mono">
                  {item.duration}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-1 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>{item.views}次观看
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}